<template>
    <div v-if="h5ConfigDetails" class="status-bar" :style="`height:${statusBarHeight}${isInIos ? 'px' : 'vh'};background: ${h5ConfigDetails[0]['fontColor']['navBg'][0]};`"></div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'StatusBar',
  props: ['prizeHis'],
  computed: {
    ...mapState(['statusBarHeight', 'isInIos', 'h5ConfigDetails', 'h5ConfigImgPath'])
  }
}
</script>

<style scoped lang="less">
  .status-bar {
    width: 100vw;
    background: rgb(20, 27, 37);
  }
</style>
